var _module = require('../components/module');

/*
round
Rounds the value to the nearest whole number
*/
_module.filter('round', function () {
    return function round(str) {
        return Math.round(Number(str));
    };
});
